
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/website-templates",
      function () {
        return require("private-next-pages/website-templates.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/website-templates"])
      });
    }
  